<form #form="ngForm" (submit)="onSubmit(form)" novalidate>

  <div class="container-fluid pubmed-container">
    <div class="container px-0">
      <div>
        <ng-container>
          <!-- Search Row -->
          <div class="search-row">
            <mat-form-field class="search-field" appearance="fill">
              <mat-icon matPrefix class="search-icon-prefix">search</mat-icon>
              <input matInput name="queryString" placeholder="{{'generic.buttons.search' | translate}}" [(ngModel)]="modelSearch.queryString" required>
            </mat-form-field>
            <button matButton="filled" color="primary" type="submit" class="search-btn" [disabled]="loading" (click)="onSubmit(form)">{{'generic.buttons.search' | translate}}</button>
          </div>

          <!-- Loading bar -->
          @if (loading) {
            <div class="row progress-bar-row">
              <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
            </div>
          }

          <!-- Filters & Sorting Toolbar -->
          @if (originalArticles && originalArticles.length > 0) {
            <div class="toolbar-row">
              <div class="filters-group">
                <mat-form-field appearance="fill" class="year-field">
                  <mat-label>{{'components.attachment.pubmed-attachment.filter-year-min' | translate}}</mat-label>
                  <input matInput type="number" name="filterMinYear" placeholder="YYYY" [(ngModel)]="filterMinYear" (ngModelChange)="currentPageIndex = 0">
                </mat-form-field>

                <mat-form-field appearance="fill" class="year-field">
                  <mat-label>{{'components.attachment.pubmed-attachment.filter-year-max' | translate}}</mat-label>
                  <input matInput type="number" name="filterMaxYear" placeholder="YYYY" [(ngModel)]="filterMaxYear" (ngModelChange)="currentPageIndex = 0">
                </mat-form-field>

                <mat-form-field appearance="fill" class="sort-field">
                  <mat-label>{{'components.attachment.pubmed-attachment.sort-by' | translate}}</mat-label>
                  <mat-select name="sortBy" [(ngModel)]="sortBy" (selectionChange)="currentPageIndex = 0">
                    <mat-option value="year_desc">{{'components.attachment.pubmed-attachment.sort-recent' | translate}}</mat-option>
                    <mat-option value="year_asc">{{'components.attachment.pubmed-attachment.sort-oldest' | translate}}</mat-option>
                    <mat-option value="title_asc">{{'components.attachment.pubmed-attachment.sort-title-asc' | translate}}</mat-option>
                    <mat-option value="title_desc">{{'components.attachment.pubmed-attachment.sort-title-desc' | translate}}</mat-option>
                    <mat-option value="authors_asc">{{'components.attachment.pubmed-attachment.sort-authors-asc' | translate}}</mat-option>
                    <mat-option value="authors_desc">{{'components.attachment.pubmed-attachment.sort-authors-desc' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <button type="button" mat-raised-button color="primary" class="add-selected-btn" [disabled]="selectedArticles.size === 0" (click)="addSelected()">
                <mat-icon>done_all</mat-icon>
                <span>{{'components.attachment.pubmed-attachment.add-selected' | translate}} ({{selectedArticles.size}})</span>
              </button>
            </div>
          }

          <!-- Articles Table -->
          @if (originalArticles && originalArticles.length > 0) {
            <div class="row table-row">
              <mat-table [dataSource]="paginatedArticles" style="width: 100%;" class="table-primary">
                
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                  <mat-header-cell *matHeaderCellDef style="flex: 0 0 8% !important">
                    <mat-checkbox (change)="$event ? toggleAllVisible() : null"
                                  [checked]="isAllSelected"
                                  [indeterminate]="isIndeterminate"
                                  color="primary">
                    </mat-checkbox>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" style="flex: 0 0 8% !important">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? toggleArticleSelection(element) : null"
                                  [checked]="isArticleSelected(element)"
                                  color="primary">
                    </mat-checkbox>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ArticleTitle">
                  <mat-header-cell *matHeaderCellDef style="flex: 0 0 62% !important">{{'components.attachment.pubmed-attachment.article-title' | translate}}</mat-header-cell>
                  <mat-cell *matCellDef="let element" style="flex: 0 0 62% !important"><a target="_blank" [href]="element.link">{{element.ArticleTitle}}</a></mat-cell>
                </ng-container>

                <ng-container matColumnDef="Authors">
                  <mat-header-cell *matHeaderCellDef>{{'components.attachment.pubmed-attachment.authors' | translate}}</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <mat-icon class="authors-icon" aria-hidden="false" matTooltip="{{element.Authors}}">groups</mat-icon>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="PubYear">
                  <mat-header-cell *matHeaderCellDef>{{'components.attachment.pubmed-attachment.pubyear' | translate}}</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{element.PubYear}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <button type="button" mat-button color="primary" (click)="addAttachment(element)">
                      <small>{{'generic.buttons.add' | translate}}</small>
                      <mat-icon>add</mat-icon>
                    </button>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" class="article-row" (click)="toggleArticleSelection(row)"></mat-row>
              </mat-table>
            </div>
          }

          <!-- Pagination -->
          @if (originalArticles && originalArticles.length > 0) {
            <div class="paginator-wrapper">
              @if (loading) {
                <mat-progress-bar mode="indeterminate" color="primary" class="paginator-loading"></mat-progress-bar>
              }
              <mat-paginator
                class="paginator-rounded"
                [length]="filteredAndSortedArticles.length"
                [pageSize]="pageSize"
                [pageIndex]="currentPageIndex"
                [disabled]="loading"
                (page)="pageChanged($event)"
                >
              </mat-paginator>
            </div>
          }

        </ng-container>
      </div>
    </div>
  </div>
</form>

